import React, { Fragment, Component } from 'react';

import { connect } from 'react-redux';
import { Alert, Button, Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import moment from 'moment';
import { gql } from 'apollo-boost';
import { Mutation } from 'react-apollo';
import SubmissionButton from '~/components/submissionButton/submissionButton';

export const completeLotTransfersMutation = gql`
  mutation completeLotTransfers($breweryId: Int!, $lotTransfers: [TransferForLotTransferComplete]!) {
    completeLotTransfers(breweryId: $breweryId, lotTransfers: $lotTransfers) {
      id
    }
  }
`;

export class ConfirmDryHopModal extends Component {
  state = {
    submitting: false
  };

  setSubmitting = submitting => {
    this.setState({
      submitting
    });
  };

  setError = error => {
    this.setState({
      error
    });
  };

  render() {
    const { isOpen, onToggle, onSuccess, brewery, refetchQueries, lotTransfers } = this.props;
    const { submitting, error } = this.state;
    return (
      <Modal isOpen={isOpen} toggle={onToggle}>
        <ModalHeader toggle={onToggle}>Confirm dry hop additions</ModalHeader>
        <Mutation mutation={completeLotTransfersMutation}>
          {completeLotTransfers => (
            <Fragment>
              <ModalBody>
                {error && <Alert color="danger">{error}</Alert>}
                <p className="mb3">Do you want to confirm that the dry hop step has been completed?</p>
                <div>
                  {lotTransfers.map((l, idx) => (
                    <div key={l.id} className="mb3 pb3 bb-divider">
                      <h4 className="mv0 f5">{l.lot.reference}</h4>
                      <p className="flex-grow-1">
                        Dry hop {l.lot.volume}L of {l.lot.product.name} on {moment(l.startDate).format('dddd, MMMM Do')}
                      </p>
                    </div>
                  ))}
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" onClick={onToggle}>
                  Cancel
                </Button>{' '}
                <SubmissionButton
                  color="primary"
                  isSubmitting={submitting}
                  onClick={async () => {
                    this.setSubmitting(true);

                    try {
                      await completeLotTransfers({
                        variables: {
                          breweryId: brewery.id,
                          lotTransfers: lotTransfers.map(l => ({
                            id: l.id
                          }))
                        },
                        awaitRefetchQueries: true,
                        refetchQueries
                      });

                      onSuccess();
                    } catch (err) {
                      console.error(err);
                      this.setError('An unknown error occured');
                      this.setSubmitting(false);
                    }
                  }}
                >
                  Confirm
                </SubmissionButton>
              </ModalFooter>
            </Fragment>
          )}
        </Mutation>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}
export default connect(mapStateToProps)(ConfirmDryHopModal);



// WEBPACK FOOTER //
// ./src/containers/confirmDryHopModal/confirmDryHopModal.jsx